import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"background-color":"rgba(0, 32, 73, 0.8)"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 국내 최고 수준의 전문가")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" & 전문 의료 기관과 협업 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 국내 최고 수준의 전문가 & 전문 의료 기관과 협업 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 여러 의료 기관의 전문의들과 함께 하이의 디지털 테라노스틱스 플랫폼에 대한 임상 시험을 진행합니다. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" AI 전문가와의 협업을 통해 데이터 수집, 분석, 모니터링, 리포팅을 할 수 있는 프로세스와 시스템을 구축합니다. ")

import { computed, ref } from "vue";
import { useDisplay } from "vuetify";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, smAndUp } = useDisplay();

const modules = ref([Autoplay, Pagination]);
const model = ref(null);

const sliderPerView = computed(() => {
  if (xs.value) return 3;
  return 5;
});

const spaceBetween = computed(() => {
  if (xs.value) return 25;
  return 60;
});

const collaborationHeight = computed(() => {
  if (xs.value) return "5rem";
  return "7rem";
});

const coworks = ref([
  {
    src: require("../../assets/comments/collaboration/collaboration_eisai.png"),
  },
  {
    src: require("../../assets/comments/collaboration/collaboration_eumcm.png"),
  },
  {
    src: require("../../assets/comments/collaboration/collaboration_eumcs.png"),
  },
  { src: require("../../assets/comments/collaboration/collaboration_gns.png") },
  { src: require("../../assets/comments/collaboration/collaboration_kmi.png") },
  {
    src: require("../../assets/comments/collaboration/collaboration_severance.png"),
  },
  { src: require("../../assets/comments/collaboration/collaboration_smu.png") },
  {
    src: require("../../assets/comments/collaboration/collaboration_snuh.png"),
  },
  { src: require("../../assets/comments/collaboration/collaboration_ysu.png") },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle([{"background-size":"cover","background-position":"center"}, {
      backgroundImage:
        'url(' +
        require('../../assets/comments/collaboration/collaboration_background.webp') +
        ')',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, { style: {"max-width":"1200px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "elevation-0 text-white py-10",
            style: {"background-color":"transparent"}
          }, {
            default: _withCtx(() => [
              (_unref(xs))
                ? (_openBlock(), _createBlock(_component_v_card_title, {
                    key: 0,
                    class: "text-h5 font-weight-bold text-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_card_title, {
                    key: 1,
                    class: "text-h4 font-weight-bold text-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })),
              _createVNode(_component_v_card_text, {
                class: _normalizeClass(["text-center text-white mx-auto font-weight-medium", { 'text-body-2': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                style: {"word-break":"keep-all"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_spacer, { class: "py-4" }),
              _createVNode(_unref(Swiper), {
                slidesPerView: _unref(sliderPerView),
                loop: true,
                spaceBetween: _unref(spaceBetween),
                centeredSlides: true,
                autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
                modules: modules.value,
                class: "mySwiper",
                style: {"width":"75%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coworks.value, (cowork, index) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                      key: index,
                      style: {"background-color":"transparent"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: cowork.src,
                          height: _unref(collaborationHeight)
                        }, null, 8, ["src", "height"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["slidesPerView", "spaceBetween", "modules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 4))
}
}

})